import { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './Profile.module.scss';

const ResumeProfile = memo(({ user }) => {
  return (
    <div className={classNames(Styles.section, Styles.top)}>
      <div className={Styles.pictureContainer}>
        {user?.profile?.picture && (
          <img className={Styles.picture} src={user.profile.picture} alt={user.name} />
        )}
      </div>
      <div className={Styles.profileInfo}>
        {user.portfolio?.primarySkill && (
          <p className={Styles.primarySkill}>{user.portfolio.primarySkill.noun}</p>
        )}
        <h1 className={Styles.name}>{user.name}</h1>
        {user.profile?.headline && (
          <p className={Styles.profileHeadline}>{user.profile.headline}</p>
        )}
        {user.profile?.description && (
          <p className={Styles.description}>{user.profile.description}</p>
        )}
        {(user.portfolio?.orderedSkills.length > 0 && (
          <div className={Styles.keywords}>
            {user.portfolio.orderedSkills.map((skill, j) => (
              <div key={j} className={Styles.keyword}>
                {skill.label}
              </div>
            ))}
          </div>
        )) ||
          ''}
      </div>
    </div>
  );
});

ResumeProfile.propTypes = {
  className: PropTypes.string,
};

export default ResumeProfile;
